import { getHeaderHeight } from 'core/utils';

export * from 'widgets/toolbox/scroll';

/**
 * @description Scroll window to provided element only if element is not in viewport
 * @param element - HTML Element
 * @param isCountHeaderHeight - add to top header height
 * @param isCentered - centers the element inside the window
 */
export function scrollWindowTo(element?: HTMLElement, isCountHeaderHeight = false, isCentered = false, isCountMobileSearchHeight = false): void {
    if (!element) {
        return;
    }

    const headerHeight = getHeaderHeight(isCountMobileSearchHeight);
    let top = element.getBoundingClientRect().top + window.pageYOffset;

    if (isCentered) {
        top -= (window.innerHeight - element.offsetHeight) / 2;
    }

    const left = 0;

    if (element.getBoundingClientRect().bottom > window.innerHeight || element.getBoundingClientRect().top < 0) {
        if (isCountHeaderHeight) {
            window.scrollTo({ top: top - headerHeight, left: left, behavior: 'smooth' });
        } else {
            window.scrollTo({ top: top, left: left, behavior: 'smooth' });
        }
    }
}
